import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { DashboardService } from '../../../api/dashboard/dashboard.service';
declare var $: any;
declare var jQuery: any;
@Component({
    selector: 'subscriptionreport-page',
    templateUrl: './subscriptionreport.html'
})
export class SubscriptionReportComponent implements OnInit {
    roleType: string;
    selectDeviceType : string = "All";
    progressPer :string = "0%";

    total_totaluser : number = 0;
    total_subscription_ispremiumuser : number = 0;
    total_subscription_isprouser : number = 0;
    total_subscription_isupgradetopro : number = 0;
    total_subscription_ispurchase : number = 0;

    constructor(
        private dashboardService: DashboardService,
        private router: Router
    ) {
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN'  || localStorage.getItem('type') == 'GENEROSITY')) {
            $('.nav-item a').click(function () {
                $('a.nav-link.active').removeClass('active')
                $('a.nav-link').addClass('nav-link');
                $(this).addClass("active");
            });
            $(function () {
                $("[data-toggle=popover]").popover();
                $("[data-toggle=popover-hover]").popover({
                    trigger: 'hover'
                });
                $("[data-toggle=tooltip]").tooltip();
            });
            $(function(){
               $('#subscriptionTableID').DataTable({
                paging: false,
                info: false,
                  order: [[2, 'desc']],
                });
              });
            this.selectDeviceType = "All";
            this.progressPer = "0%";
            this.roleType = localStorage.getItem("type");
            this.initData();
        }
        else {
            this.router.navigate(['/']);
        }
    }
    initData() {
        $(function () {
            var t = $('#subscriptionTableID').DataTable();
            t.clear().draw();
        });
        this.total_totaluser = 0;
        this.total_subscription_ispremiumuser = 0;
        this.total_subscription_isprouser = 0;
        this.total_subscription_isupgradetopro = 0;
        this.total_subscription_ispurchase = 0;
        this.progressPer = "35%";
        var JDDD = {
            devicetype : this.selectDeviceType
        }
        this.dashboardService.subscriptionreport(JDDD).then(data => {
            this.progressPer = "100%";
            for (let index = 0; index < data.data.length; index++) {
                const element = data.data[index];
                if(element.countryname != null && element.countryname != "")
                {
                    this.total_totaluser += parseInt(element.totaluser);
                    this.total_subscription_ispremiumuser += parseInt(element.subscription_ispremiumuser);
                    this.total_subscription_isprouser += parseInt(element.subscription_isprouser);
                    this.total_subscription_isupgradetopro += parseInt(element.subscription_isupgradetopro);
                    this.total_subscription_ispurchase += parseInt(element.subscription_ispurchase);
                    $(function () {
                        var t = $('#subscriptionTableID').DataTable();
                        t.row.add([element.countryname, element.totaluser, element.subscription_ispremiumuser, element.subscription_isprouser,element.subscription_isupgradetopro, element.subscription_ispurchase]).draw(false);
                    });
                }
            }
            this.progressTimeOut();
        }
        );
    }
    progressTimeOut()
    {
      setTimeout(()=>
      { 
        this.progressPer = "0%"; 
      },200);
    }

    onDeviceTypeChange(dType)
    {
        this.selectDeviceType = dType;
        this.initData();
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/subscriptionreport/subscriptionreport.page.ts